import { FC } from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import Logo from "../../assets/logo.png";

export const Footer: FC = () => {
  return (
    <div className="Footer">
      <div className="Footer_logo Footer-section">
        <img src={Logo} alt="Prosoft Engineering" />
      </div>
      <div className="Footer_contact Footer-section">
        <span className="Footer_header">Contact</span>
        <div className="Footer-section-content">
          <div className="Footer_contact-address">
            <span>500 Viking Drive - Suite 301</span>
            <span>Virginia Beach, VA 23452</span>
          </div>
          <div className="Footer_contact-telephony">
            <span>Office: (757) 431-2400</span>
            <span>Fax: (757) 463-1071</span>
            <span>Email: info@prosoft.us.com</span>
          </div>
        </div>
      </div>
      <div className="Footer_links Footer-section">
        <span className="Footer_header">Quick Links</span>
        <ul>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/solutions">Solutions</Link>
          </li>
          <li>
            <Link to="/careers">Careers</Link>
          </li>
          <li>
            <Link to="/contract-vehicles">Contract Engagement</Link>
          </li>
          <li>
            <Link to="/news">News and Awards</Link>
          </li>
          <li>
            <Link to="/contacts">Contact</Link>
          </li>
        </ul>
      </div>
      <div className="Footer_copyright Footer-section">
        <span>
          &copy; 2021 Professional Software Engineering, Inc. (PROSOFT).
        </span>
        <span>
          PROSOFT is a registered ISO 9001 and an appraised CMMI-DEV ML3
          corporation.
        </span>
        <span>All Rights Reserved.</span>
      </div>
    </div>
  );
};
